import { baseClient } from "./baseRequest";

export enum PlanStatus {
  Active = "Active",
  Unlisted = "Unlisted",
  Deleted = "Deleted",
}

export type Plan = {
  id: string;
  title?: string;
  price: number;
  upfrontAmount: number;
  revSharePercentage: number;
  isAdvanced: boolean;
  explanation?: string;
  /** Optional "was" price, shown struck through on the storefront. */
  compareAtPrice?: number;
  status: PlanStatus;
  createdAt: string;
  updatedAt: string;
};

export type CreatePlanDto = {
  title?: string;
  price: number;
  compareAtPrice?: number;
  upfrontAmount: number;
  revSharePercentage: number;
  isAdvanced: boolean;
  explanation?: string;
  status?: PlanStatus;
};

const planApiClient = {
  getAvailablePlans: (): Promise<Plan[]> =>
    baseClient.get<Plan[]>({ url: "/admin/plans" }),

  createPlan: (dto: CreatePlanDto): Promise<Plan> =>
    baseClient.post<Plan>({ url: "/admin/plans", body: dto }),

  updateStatus: (planId: string, status: PlanStatus): Promise<void> =>
    baseClient.put<void>({
      url: `/admin/plans/${planId}/status`,
      body: { status },
    }),

  updateContent: (
    planId: string,
    data: { title?: string; explanation?: string },
  ): Promise<void> =>
    baseClient.put<void>({
      url: `/admin/plans/${planId}/content`,
      body: data,
    }),
};

export default planApiClient;
